import { cards } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热点黑料
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            51吃瓜爆料网为你精选最新最劲爆的娱乐黑料图文报道
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card) => (
            <div
              key={card.id}
              className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 group cursor-pointer hover:border-primary-200 transition-colors"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-lg bg-primary-500 text-background-50 text-xs font-medium">
                  {card.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading text-foreground-900 mb-2 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                  {card.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {card.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}